export enum FeatureToggle {
  catalogAdmin = 'catalogAdmin',
  ShowQasWorkflowActions = 'rt_catalog_admin_show_qas_workflow_actions',
  ShowCampPipelineEditor = 'rt_catalog_admin_show_camp_pipeline_editor',
  PriceAnomalyAmsApproval = 'rt_price_anomaly_patch_ams_approval',
  SourcePriorityManagementTool = 'rt_source_priority_management_tool_admin',
  // Gates the Structured Input step type, the Structured Decorator step type, and
  // the Decorator tab/category. See STRUCTURED_INPUT_GATED_TYPES /
  // STRUCTURED_INPUT_GATED_CATEGORIES for the gated surfaces.
  ShowStructuredInput = 'rt_catalog_admin_show_structured_input',
}
